import jwtAxios from 'main/services/auth/jwt-auth';
import {GET_AUTH_INFO, GLOBAL_RESET} from 'shared/constants/ActionTypes';
import {handleApiCall} from './CommonController';

export const onSignInUser = (email) => (dispatch) => {
  // 1. Wipe everything (including old menus)
  dispatch({type: GLOBAL_RESET});

  handleApiCall(
    dispatch,
    () =>
      jwtAxios.post('/m/signIn', email, {
        headers: {
          'Content-Type': 'text/plain',
        },
      }),
    (userData) => {
      dispatch({type: GET_AUTH_INFO, payload: userData});
      // dispatch(showMessage(`Welcome back, ${userData.name}!`));
    },
  );
};

export const onVerifyUser = (data) => (dispatch) => {
  handleApiCall(
    dispatch,
    () =>
      jwtAxios.post('/m/verify', data.token, {
        headers: {
          'Content-Type': 'text/plain',
        },
      }),
    (userData) => {
      dispatch({type: GET_AUTH_INFO, payload: userData});
    },
  );
};
